import { useIdentityStore } from '~/store/identity'
import { useRootStore } from '~/store/root'

export default defineNuxtPlugin(async () => {
  if (useRoute().path === '/healthcheck' || useRoute().path.startsWith('/_nuxt')) {
    return
  }

  const rootStore = useRootStore()

  if (rootStore.isEmbedded && rootStore.isLoggedIn) {
    return
  }

  const identityStore = useIdentityStore()
  await identityStore.getSupportedIdentityProvidersForClient()
  const ssoFailed = useRoute().query?.ssoFailed
  const isSsoLogin = useRoute().path.startsWith(identityStore.ssoLoginUrl)

  if (!isSsoLogin && !ssoFailed && !rootStore.isLoggedIn && identityStore.onlySsoSupported) {
    await identityStore.initiateSamlSsoLogin()
  }
})
